import classnames from "classnames";
import parse, { domToReact } from "html-react-parser";
import PropTypes from "prop-types";
import React, { useContext, useEffect, useState } from "react";
import { ContactDetailsContext } from "../../context/contact-details-context";
import ContactDetailsBox from "../contact-details-box/ContactDetailsBox";
import contactMethods from "../../constants/contactMethods";

// Components
import { SecondaryButton } from "@JohnLewisPartnership/jl-design-system/dist/elements/button/Button";

// Styles
import styles from "./contact-us-help-order-solution.module.scss";

// Utils
import { dispatchNewEvent } from "../../utils/analytics/trigger/analyticsTrigger";
import { getSolutionContactDetails } from "../../utils/data/getContactDetails";

const location = "contact-us | productStockInformation | productStockInformationHelp";

function ContactUsHelpOrderSolution({ solution: { id, title, fields }, className }) {
  const { liveChatProminenceExperiment } = useContext(ContactDetailsContext);
  // eslint-disable-next-line no-unused-vars
  const [contactDetails, setContactDetails] = useState(null);

  useEffect(() => {
    getSolutionContactDetails(location)
      .then(res => setContactDetails(res))
      .catch(() => setContactDetails(null));
  }, []);

  const handlePhoneClicked = () => {
    dispatchNewEvent("dataStateChange", {
      action: "contactUsDecisionSolution",
      type: "productStockInformation|productStockInformationHelp",
      solutionType: `partner:${contactDetails.phone.number}`,
    });
  };
  const locationOnPage = "main | contact-us";

  return (
    <article className={classnames(styles.helpOrderSolution, className)} data-solution-id={id}>
      <h2 className={styles.helpOrderSolution__top}>Did you know...</h2>
      {liveChatProminenceExperiment ? (
        <div className={styles.helpOrderSolution__inner}>
          <ContactDetailsBox
            fields={fields.filter(({ name }) => ["phone", "chat", "email"].includes(name))}
            buttonType="primary"
            solutionId={id}
            location={locationOnPage}
            contactMethods={contactMethods}
            title={
              liveChatProminenceExperiment ? "We’re here to help" : "Contact John Lewis & Partners Customer Service"
            }
            viewContactDetails
            showContactDetailsByDefault
            showGreyBackground
          />
        </div>
      ) : (
        <div className={styles.helpOrderSolution__inner} data-test="solution-inner">
          {title && <h2 data-test="solution-name">{title}</h2>}
          {parse(fields.find(({ name }) => name === "content").content, {
            replace: ({ type, name: tagName, attribs = {}, children }) => {
              return type === "tag" && attribs && React.createElement(tagName, attribs, domToReact(children));
            },
          })}
          {contactDetails && contactDetails.phone ? (
            <div className={styles["helpOrderSolution__helpOrder-details"]}>
              <div className={styles["helpOrderSolution__number-box"]}>
                <SecondaryButton
                  tag="a"
                  href={`tel:${contactDetails.phone.number}`}
                  className={styles["helpOrderSolution__number-button"]}
                  onClick={handlePhoneClicked}
                >
                  {contactDetails.phone.number}
                </SecondaryButton>
                {contactDetails.phone.displayTimes.map((oTime, i) => (
                  <p key={i} className={styles["helpOrderSolution__phone-availability"]}>
                    <span className={styles["helpOrderSolution__phone-availability-days"]}>{oTime.days}</span>
                    <span>{oTime.times}</span>
                  </p>
                ))}
              </div>
            </div>
          ) : null}
        </div>
      )}
    </article>
  );
}

ContactUsHelpOrderSolution.propTypes = {
  solution: PropTypes.shape({
    id: PropTypes.string,
    title: PropTypes.string,
    fields: PropTypes.arrayOf(
      PropTypes.shape({
        name: PropTypes.string,
        content: PropTypes.string,
      }),
    ),
    hierarchyPosition: PropTypes.arrayOf(PropTypes.string).isRequired,
  }).isRequired,
  className: PropTypes.string,
};

ContactUsHelpOrderSolution.defaultProps = {
  className: undefined,
};

export default ContactUsHelpOrderSolution;
